import { Components, Theme } from '@mui/material/styles';

export default function MuiCssBaseline(theme: Theme): Components['MuiCssBaseline'] {
  return {
    styleOverrides: {
      body: { ...theme.typography.body2 },
    },
  };
}
